<template>
    <div>
        <div class="col-12 col-lg-10 mx-auto">
            <div class="btn-group" role="group" aria-label="Basic example">
                <button
                    v-if="isAuthenticated"
                    type="button"
                    class="btn btn-primary"
                    @click="redirectToList"
                >
                    <i class="fas fa-th-list"></i> {{ $t('buttons.back.btnText') }}
                </button>
            </div>
            <dynamic-form
                :formToRegisterEntityId="formToRegisterEntityId"
                :eventName="name"
                :entryId="entryId"
                :details="details"
                :isCompleting="isCompleting"
                @saved="formSaved"
            >
            </dynamic-form>
        </div>
    </div>
</template>

<script>
    import DynamicForm from '@/components/dynamic/Form';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        components: {
            'dynamic-form': DynamicForm
        },
        props: {
            id: {
                type: [Number, String],
                required: true
            },
            entryId: {
                type: [Number, String]
            },
            name: {
                type: String
            },
            details: {
                type: Boolean,
                default: false
            },
            returnUrl: {
                type: String
            },
            isCompleting: {
                type: Boolean,
                default: false
            },
            returnOnSave: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters(['claims', 'isAuthenticated']),
            formToRegisterEntityId() {
                if (typeof this.id === 'number') {
                    return this.id;
                }

                return Number(this.id.replaceAll(' ', ''));
            }
        },
        methods: {
            redirectToList() {
                if (this.returnUrl) {
                    return this.$router.push({ path: this.returnUrl });
                } else {
                    if (this.claims.formSurvey.read) {
                        return this.$router.push({ path: '/forms/active' });
                    } else {
                        return this.$router.push({ path: '/account?tab=activeFormsTab' });
                    }
                }
            },
            formSaved(formEntityId, saveWithFiles) {
                if (this.returnOnSave) {
                    this.redirectToList()
                }
            }
        }
    }
</script>
